import MinddropsOverviewScreen from "./overview";

import { Component, ReactNode } from "react";
import { Route, Routes } from "react-router-dom";

export default class MinddropsScreen extends Component {
  render(): ReactNode {
    return (
      <Routes>
        <Route path="/:id/" element={<MinddropsOverviewScreen />} />
      </Routes>
    );
  }
}
